<template>
  <div v-show="false" role="reloader"></div>
</template>

<script>
// Utilities
import { EventBus } from '@/main'
import { authComputed } from 'Store/helpers'

export default {
  name: 'CardsAlertsReloader',

  data() {
    return {
      assetsInterval: null,
    }
  },

  methods: {
    async loadAssets() {
      if (this.isEmployee) await this.$store.dispatch('cards/getCards')
      if (this.currentAccount) {
        await this.$store.dispatch('client/loadCards', this.currentAccount.id)
      }
      // reload alerts
      await this.$store.dispatch('alerts/load')
    },

    setAssetTimeOut() {
      this.assetsInterval = setInterval(() => {
        // if (!this.loggedIn) return
        this.loadAssets()
      }, 60 * 1000)
    },

    resetInterval() {
      clearInterval(this.assetsInterval)
      this.loadAssets()
      this.setAssetTimeOut()
    },
  },

  computed: {
    ...authComputed,

    currentAccount() {
      return this.$store.state.client.account
    },
  },

  created() {
    this.setAssetTimeOut()
    EventBus.$on('reload-user-content', this.resetInterval)
  },

  beforeDestroy() {
    this.assetsInterval = null
    EventBus.$off('reload-user-content', this.resetInterval)
  },
}
</script>

<style scoped></style>
